module.exports = __webpack_public_path__ + "static/pasta-469638631564b4cc39388091d3a83c96.jpg";